import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import { useNavigate } from "react-router-dom";
import ServicePageCard from "./ServicePageCard";
import { getCategories } from "../../../api/admin/service-management";
import "./WhatWeDoSection.scss";

const WhatWeDoSection: React.FC = () => {
  const [serviceCategories, setServiceCategories] = useState<any[]>([]);
  const navigate = useNavigate();

  const isPreproductionEnv =
    (process.env.REACT_APP_ENV || process.env.NODE_ENV) === "preproduction";
  const isProductionEnv =
    (process.env.REACT_APP_ENV || process.env.NODE_ENV) === "production";

  const handleCarouselClick = (serviceId: number, needType: string) => {
    navigate("/home/list-of-funeral-homes", {
      state: {
        selectedCategoryId: serviceId,
        selectedNeedType: needType === "at_need" ? "immediate" : "pre_need",
      },
    });
  };

  const fetchAllCategories = async () => {
    try {
      const response = await getCategories({ type: "all" });
      const allCategories = response?.data?.data?.data || [];
      setServiceCategories(allCategories);
    } catch (error) {
      console.error("Failed to fetch categories:", error);
    }
  };

  useEffect(() => {
    fetchAllCategories();
  }, []);

  return (
    <Box className="what-we-do">
      {/* Header */}
      <Box className="what-we-do__header">
        <Typography className="what-we-do__title">
          <span className="what-we-do__title--light">What</span> We Do
        </Typography>
        <Typography className="what-we-do__subtitle">
          <span className="what-we-do__subtitle--primary">
            Explore Trusted Funeral &
          </span>{" "}
          <span className="what-we-do__subtitle--secondary">
            Memorial Services
          </span>
        </Typography>
      </Box>

      {/* Grid */}
      {isPreproductionEnv || isProductionEnv ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            py: 10,
            px: 4,
            textAlign: "center",
            background:
              "linear-gradient(135deg, rgba(32, 67, 70, 0.04) 0%, rgba(159, 127, 44, 0.04) 100%)",
            borderRadius: "24px",
            border: "1px solid rgba(32, 67, 70, 0.08)",
            backdropFilter: "blur(12px)",
            boxShadow: "0 12px 40px 0 rgba(32, 67, 70, 0.03)",
            maxWidth: "640px",
            margin: "0 auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 72,
              height: 72,
              borderRadius: "50%",
              background: "linear-gradient(135deg, #204346 0%, #3a7277 100%)",
              color: "#fff",
              mb: 3,
              boxShadow: "0 6px 24px rgba(32, 67, 70, 0.25)",
              animation: "pulse-sparkle 2.5s infinite ease-in-out",
              "@keyframes pulse-sparkle": {
                "0%": {
                  transform: "scale(0.96)",
                  boxShadow: "0 6px 15px rgba(32, 67, 70, 0.2)",
                },
                "50%": {
                  transform: "scale(1.04)",
                  boxShadow: "0 6px 30px rgba(32, 67, 70, 0.4)",
                },
                "100%": {
                  transform: "scale(0.96)",
                  boxShadow: "0 6px 15px rgba(32, 67, 70, 0.2)",
                },
              },
            }}
          >
            <LocalFloristIcon sx={{ fontSize: 34 }} />
          </Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: "#204346",
              mb: 1.5,
              letterSpacing: "-0.5px",
            }}
          >
            Coming Soon
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "rgba(32, 67, 70, 0.75)",
              maxWidth: "440px",
              lineHeight: 1.6,
              fontSize: "16px",
            }}
          >
            Our memorial services will be listed here soon.
          </Typography>
        </Box>
      ) : (
        <Grid
          container
          spacing={4}
          rowSpacing={5}
          columnSpacing={1}
          className="what-we-do__grid"
        >
          {serviceCategories?.map((serviceCategory) => (
            <Grid item xs={12} sm={6} md={4} key={serviceCategory?.id}>
              <div className="what-we-do__card">
                <ServicePageCard
                  serviceCategory={serviceCategory}
                  onClick={() =>
                    handleCarouselClick(
                      serviceCategory?.id,
                      serviceCategory?.needTypes?.[0],
                    )
                  }
                />
              </div>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default WhatWeDoSection;
